import { Box, Paper, Typography } from "@mui/material";
import React, { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import StepProgressBar from "src/components/CustomerOnbording/StepProgressBar";
import CustomLoader from "src/shared_components/CustomLoader";

const steps = [
    { label: "Create New Client" },
    // { label: "Payment Portal" },
    { label: "Final Submit" },
];

const getActiveStep = (pathname: string): number => {
    if (pathname.includes("CreateNewClient")) return 0;
    // if (pathname.includes("paymentPage")) return 1;
    if (pathname.includes("FinalSubmit")) return 1;
    return 0;
};

const FreeTrialLayout: React.FC = () => {
    const location = useLocation();
    const activeStep = getActiveStep(location.pathname);

    return (
        <Box>
            {/* <Box sx={{ mb: 4 }}>
                <StepProgressBar steps={steps} activeStep={activeStep} />
            </Box> */}
            <Suspense fallback={<CustomLoader />}>
                <Outlet />
            </Suspense>

        </Box>

    );
};

export default FreeTrialLayout;